import { gql } from '@apollo/client';

export const queryName = 'cancelationReasons';
export const cancelationReasonsName = 'CancelationReasons';
export const cancelationReasons = gql`
	fragment ${cancelationReasonsName} on Member {
		membershipSubscription {
			cancellationReasons {
				reasons {
					butterKey
					cancellationReasonId
				}
			}
		}
	}
`;
